export default "__VITE_ASSET__DwXBzeKu__"